import { useSelector } from 'react-redux';

export default function useOrg() {
  return useSelector((state) => state.org);
}
